function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M19.9017 7.46702C20.3798 7.96503 20.3637 8.75632 19.8657 9.23442L14.6573 14.2344C14.1736 14.6988 13.4097 14.6988 12.926 14.2344L9.801 11.2344C9.30299 10.7563 9.28684 9.96503 9.76493 9.46702C10.243 8.96901 11.0343 8.95286 11.5323 9.43095L13.7917 11.5999L18.1343 7.43095C18.6324 6.95286 19.4236 6.96901 19.9017 7.46702Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M0.25 8.33268C0.25 3.96043 3.79441 0.416016 8.16667 0.416016H24.8333C26.4442 0.416016 27.75 1.72185 27.75 3.33268V28.3327C27.75 29.9435 26.4442 31.2493 24.8333 31.2493H6.5C3.04822 31.2493 0.25 28.4511 0.25 24.9993V8.33268ZM2.75 19.9989C3.79458 19.2143 5.09299 18.7493 6.5 18.7493H25.25V3.33268C25.25 3.10256 25.0635 2.91602 24.8333 2.91602H8.16667C5.17512 2.91602 2.75 5.34114 2.75 8.33268V19.9989ZM2.75 24.9993C2.75 27.0704 4.42893 28.7493 6.5 28.7493H24.8333C25.0635 28.7493 25.25 28.5628 25.25 28.3327V21.2493H6.5C4.42893 21.2493 2.75 22.9283 2.75 24.9993Z"
});

function SvgVote(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 32,
    viewBox: "0 0 28 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVote);
export default __webpack_public_path__ + "static/media/vote.cf168b22.svg";
export { ForwardRef as ReactComponent };